import ng from 'angular';
import {
    OrganismEditFormSslCertificateController,
    EditPanelRight
} from '@/atomic-components';
import { CertificateRenewHotline } from '@/atomic-components/organisms/forms/edit-forms/ssl/ssl-certificate-edit-callcenter';

export class OrganEditPanelSslCertificateRenewController {

    public $editFormOrganism: OrganismEditFormSslCertificateController;
    public panelRight: EditPanelRight;
    public cancelCallback: () => void;
    public renewConfirm = false;
    public changeCsr = false;
    public hotline: CertificateRenewHotline;
    public csrTemp: string;

    public set csrInput(csr: string) {
        this.csrTemp = csr;
        if (this.hotline.changedCsr !== undefined) {
            this.hotline.changedCsr(this.csrTemp);
        }
    }

    public get csrInput(): string {
        if (this.hotline.csrInput === this.csrTemp) {
            return this.hotline.csrInput;
        }
        return ''; // what to do, throwing seems to be too much
    }


    public get enableRenewing() {
        return this.renewConfirm;
    }

    public cancel = () => {
        this.renewConfirm = false;
        if ([undefined, null].indexOf(this.cancelCallback) === -1) {
            this.cancelCallback();
        }
    };

    public resetCsr = () => {
        this.csrInput = '';
    }
}

export class OrganEditPanelSslCertificateRenewComponent implements ng.IComponentOptions {
    public bindings = {
        cancelCallback: '<cancel',
        panelRight: '<',
        hotline: '<',
    };
    public require = {
        $editFormOrganism: '^organismEditFormSslCertificate'
    };
    public controller = OrganEditPanelSslCertificateRenewController;
    public template = require('./ssl-certificate-renew.html');
}
